import styled from 'styled-components';
import {FlexItemCenter} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';
import {textSizes} from '@stencil/build-theme';
export const NoDiningWrapper = styled(FlexItemCenter)(
  props => `
    background-color:#fff5f7;
    padding:${props.theme.spacing.custom(5)} ${props.theme.spacing.custom(7)};
    border-radius: 8px;
    width:fit-content;
    
    `,
);
export const NoDiningText = styled.span`
  ${textSizes.MediumW3}
  color:#ff3a5c;
  margin-left: ${props => props.theme.spacing.base};
`;
